/**
 * @class
 * @override
 */
import Base from 'netxcore@netx/core-app/views/menuView';

import MaterialMenus from '@netx/core/functionality/materialMenus';

class MenuView extends Base {
	/** @override */
	constructor(opts = {}) {
		super(opts);

		this.removeOnHide = opts.removeOnHide === true;
	}

	/** @override */
	doTemplate() {
		let html = super.doTemplate();

		// First, kill bootstrap toggle
		html = html.replace(/data-toggle="dropdown"/g, '');
		html = html.replace(/class="divider"/g, 'class="mdc-list-divider"');

		return html;
	}

	/** @method */
	onMenuClose() {
		if (this.removeOnHide) {
			this.remove();
		}
	}

	/** @override */
	postRender() {
		const el = this.el;
		// A quick and dirty way to make our menus behave as material design
		// until we reqork menus and allow for proper theming
		// Store for `configureSubmenus`
		const isHeaderTitleActions = (this.isHeaderTitleActions =
			el.classList.contains('header__title-actions'));

		// When in a drawer we need to unwrap and discard the 'mdc-list' element
		// as you can only have one in a drawer (they do not appear to currently support mdc-list groups in drawers)
		const isInDrawer = el.classList.contains('drawer-menu');
		if (isInDrawer) {
			const lists = el.querySelectorAll('.mdc-list');
			lists.forEach((list) => {
				const parent = list.parentNode;
				while (list.firstChild) parent.insertBefore(list.firstChild, list);
				parent.removeChild(list);
			});
		}

		// Context menu
		if (this.context) {
			// We need to just hack at the thing - we are making this so that mdc-menus
			// "just work" with our sontext menus
			const toggleEl = el.querySelector('.dropdown-toggle');
			toggleEl && toggleEl.parentNode.removeChild(toggleEl);
			const wrapperEl = el.querySelector('.dropdown-menu');
			if (wrapperEl) {
				el.appendChild(wrapperEl.firstChild);
				wrapperEl.parentNode.removeChild(wrapperEl);
			}
		}

		// Store for `configureSubmenus`
		const dropdownParent = (this.dropdownParent =
			el.querySelector('.dropdown.parent'));
		this.listActions = dropdownParent
			? [...dropdownParent.querySelectorAll('.nx-action')]
			: [];
		if (dropdownParent) {
			dropdownParent.classList.add('mdc-menu-surface--anchor');
			this.checkDropdownParent(dropdownParent);
		}

		if (this.context || dropdownParent) {
			const menuEl = (this.context ? el : dropdownParent).querySelector(
				'[role="menu"]',
			);
			if (menuEl) {
				// We need to wrap our menu because mdc expects the .mdc-list to live within the menu and not be
				// the menu - this is a limiatation of our menu system atm
				const mdcMenuWrapper = document.createElement('div');
				mdcMenuWrapper.classList.add(
					'mdc-menu',
					'mdc-menu-surface',
					'mdc-menu--hoist',
				);

				menuEl.parentNode.insertBefore(mdcMenuWrapper, menuEl);
				mdcMenuWrapper.appendChild(menuEl);

				menuEl.classList.add('mdc-list');
				menuEl.querySelectorAll('li').forEach((li) => {
					li.classList.add('mdc-list-item');
				});
			}
		}

		const dropdownEl = el.querySelector('.dropdown-menu');
		if (dropdownEl) {
			// Inject the cancel button if we ar enot in a drawer
			if (!dropdownEl.closest('.mdc-drawer__content')) {
				const cancelLi = document.createElement('li');
				cancelLi.classList.add('nx-cancel', 'cancel', 'mdc-list-item');
				cancelLi.innerText = i18n.t('i18n.cancel');
				dropdownEl.appendChild(cancelLi);
			}

			const menuEl = dropdownEl.querySelector('[role="menu"]');
			if (menuEl) {
				menuEl.classList.add('mdc-list');
				menuEl.querySelectorAll('li').forEach((li) => {
					li.classList.add('mdc-list-item');
				});
			}
		}

		if (isHeaderTitleActions) {
			this.$el
				.find('a.dropdown-toggle')
				.addClass('mdc-fab', 'mdc-ripple-surface')
				.attr('aria-label', 'Actions')
				.find('svg')
				.addClass('mdc-fab__icon');
		}

		// Store for `configureSubmenus`
		this.listEl = this.el.querySelector('.mdc-list');

		super.postRender();
	}

	/**
	 * @method
	 */
	checkDropdownParent(dropdownParent) {
		if (!dropdownParent || this.isHeaderTitleActions) return;

		// For when the menu was already defining each item as an mdc-icon-button
		dropdownParent.classList.remove('mdc-icon-button');

		const hasEnabledActions = this.listActions.some(
			(listAction) => listAction.getAttribute('disabled') == null,
		);
		if (!hasEnabledActions) {
			dropdownParent.setAttribute('disabled', true);
		} else {
			dropdownParent.removeAttribute('disabled');
			const dropdowntoggle = dropdownParent.querySelector('.dropdown-toggle');
			if (dropdowntoggle) {
				dropdowntoggle.classList.add('mdc-icon-button', 'mdc-ripple-surface');
				dropdowntoggle.classList.remove('mdc-button');
				dropdowntoggle.classList.remove('mdc-button--unelevated');
			}
		}
	}

	/** @override */
	configureSubmenus() {
		super.configureSubmenus();

		// One more dirty thing!
		// Do not show item seperator if there are not any enabled actions
		// to follow
		if (this.listEl) {
			this.listEl.querySelectorAll('.mdc-list-divider').forEach((dividerEl) => {
				const menuEl = dividerEl.nextSibling;
				if (!menuEl) return;

				const hasEnabledAction = menuEl.querySelector(
					'.nx-action:not(.disabled)',
				);

				dividerEl.style.display = hasEnabledAction ? '' : 'none';
				menuEl.style.display = hasEnabledAction ? '' : 'none';
			});
		}
		this.checkDropdownParent(this.dropdownParent);
	}
}

MaterialMenus(MenuView);

export default MenuView;
